import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var CarouselControl =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CarouselControl, _PureComponent);

  function CarouselControl() {
    _classCallCheck(this, CarouselControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CarouselControl).apply(this, arguments));
  }

  _createClass(CarouselControl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          direction = _this$props.direction,
          large = _this$props.large,
          hintText = _this$props.hintText;
      return React.createElement("a", {
        className: "carousel-control",
        style: disabled ? {
          visibility: 'hidden'
        } : {},
        role: "button",
        onClick: !disabled ? onClick : undefined
      }, React.createElement("i", {
        className: "fa".concat(large ? ' fa-lg' : '', " fa-angle-").concat(direction),
        "aria-hidden": "true"
      }), React.createElement("span", {
        className: "sr-only"
      }, hintText));
    }
  }]);

  return CarouselControl;
}(PureComponent);

export { CarouselControl as default };
CarouselControl.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  large: PropTypes.bool,
  hintText: PropTypes.string
};